// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"321":"7390b7bc","498":"820c0c62","561":"2c65cdf7","879":"7ae80b23"}[chunkId] + ".css";
};